import React from 'react';
import {
  Box, Tabs, TabList, TabPanels, Tab, TabPanel,
} from '@chakra-ui/react';
import TablaCamiones from './TablaCamiones';
import TablaRutas from './TablaRutas';
import TablaRecorridos from './TablaRecorridos';

const Recoleccion: React.FC = () => {
  return (
    <Box px={{ base: 2, md: 4 }} pt={79} pb={4}>
      <Tabs colorScheme="red" variant="enclosed">
        <TabList>
          <Tab _selected={{ color: 'white', bg: '#5b182b' }} fontSize="sm" fontWeight="bold">Camiones</Tab>
          <Tab _selected={{ color: 'white', bg: '#5b182b' }} fontSize="sm" fontWeight="bold">Rutas</Tab>
          <Tab _selected={{ color: 'white', bg: '#5b182b' }} fontSize="sm" fontWeight="bold">Recorridos</Tab>
        </TabList>
        <TabPanels>
          <TabPanel px={0}><TablaCamiones /></TabPanel>
          <TabPanel px={0}><TablaRutas /></TabPanel>
          <TabPanel px={0}><TablaRecorridos /></TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  );
};

export default Recoleccion;
